// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-4f38d332] #forwardMessage .modal-header {\n  border-bottom: none;\n}\n[data-v-4f38d332] #forwardMessage .modal-body {\n  padding-top: 0;\n}\n[data-v-4f38d332] #customercare-note {\n  padding-left: 0;\n  padding-right: 0;\n}\n.btn-block + .btn-block[data-v-4f38d332] {\n  margin-top: 0;\n}\n", ""]);
// Exports
module.exports = exports;
